/**
 * Created by jonas on 2021-11-19.
 */

export class LayersSet {

    public maskedNormal:PIXI.Container;
    public maskedOver:PIXI.Container;
    public win:PIXI.Container;
    public winOver:PIXI.Container;
    public overlay:PIXI.Container;
    public stickyOverlay:PIXI.Container;
    public lockOverlay:PIXI.Container;

    public all:PIXI.Container[];

    constructor(namePrefix:string = "", nameSuffix:string = "") {
        this.maskedNormal = new PIXI.Container();
        this.maskedOver = new PIXI.Container();
        this.win = new PIXI.Container();
        this.winOver = new PIXI.Container();
        this.overlay = new PIXI.Container();
        this.stickyOverlay = new PIXI.Container();
        this.lockOverlay = new PIXI.Container();


        this.maskedNormal.name = `${namePrefix}normal${nameSuffix}`;
        this.maskedOver.name = `${namePrefix}normalOver${nameSuffix}`;
        this.win.name = `${namePrefix}win${nameSuffix}`;
        this.winOver.name = `${namePrefix}winOver${nameSuffix}`;
        this.overlay.name = `${namePrefix}overlay${nameSuffix}`;
        this.stickyOverlay.name = `${namePrefix}stickyOverlay${nameSuffix}`;
        this.lockOverlay.name = `${namePrefix}lockOverlay${nameSuffix}`;
        this.all = [this.maskedNormal, this.maskedOver,this.win, this.winOver, this.overlay, this.stickyOverlay, this.lockOverlay];
    }

    public addLayerSet(layerSet:LayersSet) {
        this.maskedNormal.addChild(layerSet.maskedNormal);
        this.maskedOver.addChild(layerSet.maskedOver);
        this.win.addChild(layerSet.win);
        this.winOver.addChild(layerSet.winOver);
        this.overlay.addChild(layerSet.overlay);
        this.stickyOverlay.addChild(layerSet.stickyOverlay);
        this.lockOverlay.addChild(layerSet.lockOverlay)
    }


}